import Keycloak from 'keycloak-js'

const keycloak = new Keycloak({
  url: process.env.REACT_APP_AUTH_SERVER_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM ?? 'master',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT ?? '',
})

export default keycloak
